module.exports = Em.TextArea.extend({
    attributeBindings: ['value', 'name', 'disabled', 'cy:data-cy']
});